import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    categoryData: []
}

const actions = {
    loadCategory: function () {
        fetch(host + "/api/project/category", {
            method: "get",
            mode: "cors",
            headers: {
              "Access-Token": localStorage.getItem("token")
            },
            credentials: "include",
            body: {}
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.Success) {
                    this.state.categoryData = data.Data;
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

}

export default{
    namespaced:true,
    state,
    actions,

}
